import script from "./ManageEvents.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageEvents.vue?vue&type=script&setup=true&lang=ts"

import "./ManageEvents.vue?vue&type=style&index=0&id=218cba9e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-218cba9e"]])

export default __exports__